import d from "./ghl-ui.es1397.js";
import V from "./ghl-ui.es666.js";
import j from "./ghl-ui.es771.js";
import y from "./ghl-ui.es667.js";
import c from "./ghl-ui.es675.js";
import g from "./ghl-ui.es1209.js";
import O from "./ghl-ui.es641.js";
import C from "./ghl-ui.es352.js";
import M from "./ghl-ui.es676.js";
import P from "./ghl-ui.es728.js";
import w from "./ghl-ui.es345.js";
import x from "./ghl-ui.es1266.js";
import D from "./ghl-ui.es1211.js";
import b from "./ghl-ui.es1399.js";
import F from "./ghl-ui.es1274.js";
function U(t, p, o, v, A, l, f) {
  var i = b(t, o), e = b(p, o), s = f.get(e);
  if (s) {
    d(t, o, s);
    return;
  }
  var r = l ? l(i, e, o + "", t, p, f) : void 0, m = r === void 0;
  if (m) {
    var a = O(e), n = !a && M(e), u = !a && !n && D(e);
    r = e, a || n || u ? O(i) ? r = i : C(i) ? r = y(i) : n ? (m = !1, r = V(e, !0)) : u ? (m = !1, r = j(e, !0)) : r = [] : x(e) || g(e) ? (r = i, g(i) ? r = F(i) : (!w(i) || P(i)) && (r = c(e))) : m = !1;
  }
  m && (f.set(e, r), A(r, e, v, l, f), f.delete(e)), d(t, o, r);
}
export {
  U as default
};
